export const STATUS_IDLE = 'IDLE'
export const STATUS_RESPONDING = 'RESPONDING'
export const STATUS_RESPONDED = 'RESPONDED'
export const TEN_MINUTES_IN_MILLISECONDS = 600000